/**
 * "Integrationen"-Tab im Mandanten-Kontrollzentrum (Admin-Bereich V2 P1,
 * docs/KONZEPT-ADMIN-BEREICH.md § "Mandanten-Detail, 8 Tabs" Punkt 4: "Status-Kacheln
 * (Verbunden/Nicht verbunden), NIE Secrets im Klartext").
 *
 * Keine eigene Datenabfrage: `stripeAccountId` kommt bereits aus dem `GET
 * /api/admin/tenants/:id`-Aufruf in `tenant-detail.tsx` (dieselbe Antwort, die auch die
 * Uebersicht zeigt) — ein zweiter Netzwerk-Ruf nur fuer diesen Tab waere unnoetig.
 *
 * Bewusst NUR eine Kachel: laut Konzept-Gap-Liste ("Integrationen nicht zentral sichtbar") gibt
 * es fuer Lexoffice/WhatsApp/eSign heute KEINEN Admin-Lese-Endpunkt (`whatsappPhoneNumberId` hat
 * laut Konzept "ueberhaupt keinen Schreibendpunkt", `lexofficeApiKey` darf ohnehin nie im
 * Klartext zurueckgegeben werden). Ein kleiner, ehrlicher Tab mit der einzigen tatsaechlich
 * verfuegbaren Integration ist besser als erfundene Kacheln fuer Felder, die die API nicht
 * liefert (harte Vorgabe der Iteration).
 */
import { StatusPill } from "../../../ui/components";
import type { StatusMeta } from "../../../ui/format";

export function IntegrationenTab({ stripeAccountId }: { stripeAccountId: string | null }) {
  const status: StatusMeta = stripeAccountId
    ? { label: "Verbunden", tone: "success" }
    : { label: "Nicht verbunden", tone: "neutral" };

  return (
    <div className="card mt-4 overflow-hidden">
      <div className="border-b border-outline-variant/30 px-4 py-3 dark:border-outline/30">
        <h3 className="font-body-sm text-body-sm font-semibold text-on-background dark:text-inverse-on-surface">
          Integrationen
        </h3>
        <p className="mt-1 font-body-sm text-[12.5px] text-secondary-fixed-dim">
          Weitere Integrationen (Lexoffice, WhatsApp, eSign) sind über die Admin-API aktuell nicht
          zentral einsehbar — dieser Tab zeigt ausschließlich, was <code>GET /api/admin/tenants/:id</code>{" "}
          tatsächlich liefert.
        </p>
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between gap-3 rounded-[10px] border border-outline-variant/30 p-3 dark:border-outline/30">
          <div>
            <p className="font-body-sm text-body-sm font-semibold text-on-background dark:text-inverse-on-surface">
              Stripe
            </p>
            {stripeAccountId && (
              <p className="mt-0.5 font-mono text-[12px] text-secondary-fixed-dim">{stripeAccountId}</p>
            )}
          </div>
          <StatusPill meta={status} />
        </div>
      </div>
    </div>
  );
}
